<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="templateEntryId" class="my-4">{{'nav.templateSourceEntries.edit' | translate}}</h3>
              <h3 *ngIf="!templateEntryId" class="my-4">{{'nav.templateSourceEntries.create' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.dirty && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <label class="form-label" for="Valid">{{'lang.globals.validity' | translate}}</label>
                    <div class="d-flex" id="Valid">
                      <sb-local-date-range-input [from]="from" [till]="till" [today]="null"
                                                 (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
                    </div>
                  </div>
                </div>
              </div>
              <table class="table">
                <thead>
                <tr>
                  <th>{{'lang.globals.templateVariables.name' | translate}}</th>
                  <th>{{'lang.globals.templateVariables.type' | translate}}</th>
                  <th>{{'lang.globals.templateVariables.value' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                  @for (variable of templateVariables; track variable.name) {
                    <tr>
                  <td>
                    {{variable?.name}}
                  </td>
                  <td>
                    {{variable?.type}}
                  </td>
                  <td class="form-group validateMe">
                    <div *ngIf="variable.type === TemplateVariableType.TEXT">
                      <input class="form-control" [(ngModel)]="templateEntry?.values[variable?.name]"
                             [value]="templateEntry?.values[variable?.name]"
                             [ngModelOptions]="{standalone: true}"
                             [class.ng-valid]="validate(variable?.name, variable?.type)"
                             [class.ng-invalid]="!validate(variable?.name, variable?.type)">
                      <span class="form-text text-muted">
                      {{'lang.globals.templateSourceEntries.text' | translate}}</span>
                    </div>
                    <div
                      *ngIf="variable.type === TemplateVariableType.IMAGE">
                      <input class="form-control" [(ngModel)]="templateEntry?.values[variable?.name]"
                             [value]="templateEntry?.values[variable?.name]"
                             [ngModelOptions]="{standalone: true}"
                             [class.ng-valid]="validate(variable?.name, variable?.type)"
                             [class.ng-invalid]="!validate(variable?.name, variable?.type)">
                      <span class="form-text text-muted">
                      {{'lang.globals.templateSourceEntries.image' | translate}}</span>
                    </div>
                  </td>
                </tr>
                  }
                </tbody>
              </table>
              <div class="wizard__footerActions">
                <button
                  type="button"
                  (click)="navService.navigateToPoint(util.RoutingID.templateSources,null , {queryParams: {templateGroupID: templateGroupId, collapse: templateSourceId}})"
                  class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</button>
                <button (click)="updateTemplateSource()"
                        type="button" [disabled]="!form.valid || loading || isAnyVariableInvalid()"
                           class="btn-success btn-wide btn-lg btn">
                  {{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
